import type { TeamsActivationResponse } from "types/generated";

import { TeamsActivationRefusedError } from "../utils/teamsActivation";

import api from "./index";

// The shared interceptor turns every error into a message string, which loses
// the status the wait needs. A 4xx other than 401 (which the interceptor must
// still see, to refresh the token) comes back as a response instead.
const keepsClientErrors = (status: number) => status < 500 && status !== 401;

// Never claims the purchase event: only front-v2's done page sends it.
export const getTeamsActivation = async (
  signal?: AbortSignal,
): Promise<TeamsActivationResponse> => {
  const response = await api.post<TeamsActivationResponse>(
    "/payments/teams-activation",
    undefined,
    { signal, validateStatus: keepsClientErrors },
  );
  if (response.status >= 400) {
    throw new TeamsActivationRefusedError(response.status);
  }
  return response.data;
};
